export function changeLanguageIfNeeded(oldLang: string, newLang: string, window: Window): void {
  if (oldLang === newLang) return;
  window.location.href = window.location.href.replace(new RegExp(`/${oldLang}/(.*)$`), `/${newLang}/$1`);
}
